<template>
  <footer class="mt-auto">
    <div class="container-fluid">
      <div class="row pb-2">
        <div class="col text-center">
          Copyright © {{year}} <strong>АдминСофт Плюс ООД</strong>, Всички права запазени.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer-component",
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
}
</script>

<style scoped>

</style>
